<template>
  <a class="cursor-pointer" data-testid="purchased-card" @click="redirectToDetail">
    <BlCardMv class="purchased-card flex flex-col rounded">
      <div class="flex">
        <BlProductImageAv
          :image-url="courseImg"
          image-placeholder="https://s2.bukalapak.com/attachment/237412/placeholder.png"
          size="extra-small"
          object-fit="contain"
          class="rounded"
        />
        <div class="w-fit ml-4">
          <BlTextAv variation="caption-12" weight="bold" :ellipsis="1">{{ purchasedCourse.sku_name }}</BlTextAv>
          <div v-if="purchasedCourse.schedule_date" class="flex items-center mt-4">
            <IcoCalendarMinor color="#8D8D8D" class="h-4 w-4" />
            <BlTextAv data-testid="shedule_date" variation="caption-10" :ellipsis="1">{{ purchasedCourse.schedule_date }}</BlTextAv>
          </div>
        </div>
      </div>
      <div class="purchased-card__dashed mv-8" />
      <BlTextAv variation="caption-10" class="mb-8" :ellipsis="1">Kode voucher</BlTextAv>
      <div class="purchased-card__voucher p-4 rounded" @click.stop.prevent>
        <BlTextAv variation="caption-12" weight="bold" :ellipsis="1">{{ purchasedCourse.voucher_code }}</BlTextAv>
        <IcoDuplicate class="h-5 w-5 cursor-pointer" data-testid="copy_button" @click.native="handleCopyButton" />
      </div>
    </BlCardMv>
  </a>
</template>

<script>
import {BlProductImageAv, BlCardMv, BlTextAv} from '@bukalapak/bazaar-mweb-latest';
import {optimizeImageWidth} from 'shared_js/image-helpers';
import {IcoCalendarMinor, IcoDuplicate} from '@bukalapak/bazaar-visual-next';
import {TRACKER_EVENT_VP_PRAKERJA_COUPON_LIST} from '../../config/tracker-events';
import trackerGenerator from '../../mixins/tracker-generator';

export default {
  name: 'PurchasedCourseCard',
  components: {
    BlProductImageAv,
    BlCardMv,
    BlTextAv,
    IcoCalendarMinor,
    IcoDuplicate,
  },
  mixins: [trackerGenerator],
  props: {
    purchasedCourse: {
      type: Object,
      required: true,
    },
  },
  computed: {
    courseImg() {
      return `${this.optimizeImageWidth(this.purchasedCourse.image_url, 92)}.webp`;
    },
    transactionDetailLink() {
      return `/transaksi/${this.purchasedCourse.deal_transaction_id}`;
    },
  },
  methods: {
    optimizeImageWidth,
    async handleCopyButton() {
      let element = document.createElement('input');
      document.body.appendChild(element);
      element.setAttribute('value', this.purchasedCourse.voucher_code);
      element.select();
      document.execCommand('copy');
      document.body.removeChild(element);
      this.$store.dispatch('onSnackbarShow', {message: 'Kode voucher berhasil disalin'});

      const trackerPayload = {
        action: 'click_copy',
        voucher_code: this.purchasedCourse.voucher_code,
        sku_name: this.purchasedCourse.sku_name,
        invoice_id: this.purchasedCourse.invoice_id,
      };
      this.mixinSendTracker(TRACKER_EVENT_VP_PRAKERJA_COUPON_LIST, trackerPayload);
    },

    redirectToDetail() {
      const trackerPayload = {
        action: 'click_card',
        voucher_code: this.purchasedCourse.voucher_code,
        sku_name: this.purchasedCourse.sku_name,
        invoice_id: this.purchasedCourse.invoice_id,
      };
      this.mixinSendTracker(TRACKER_EVENT_VP_PRAKERJA_COUPON_LIST, trackerPayload);
      this.$router.push(`/transaksi/${this.purchasedCourse.deal_transaction_id}`);
    },
  },
};
</script>

<style lang="scss" scoped>
.purchased-card {
  padding: 12px 8px;
  min-width: 254px;
  &__dashed {
    border-top: 1px dashed #e0e0e0;
  }
  &__voucher {
    background-color: #f2f2f2;
    display: flex;
    justify-content: space-between;
    align-items: center;
    cursor: default;
  }
}
</style>
